import { ScheduleType, week, weekArr } from './types'

const getGroupStart = (group: string) => group.split('-')[0]
const getGroupEnd = (group: string) =>
  group.split('-')[group.split('-').length - 1]
const getDayNum = (code: string) => Number(code[0])

const groupConsecutiveDays = (days: string[]) => {
  const sorted = [...days].sort((a, b) => Number(a[0]) - Number(b[0]))
  if (!sorted.length) return []

  const groups: string[] = []
  let start = sorted[0]
  let prev = sorted[0]

  for (let i = 1; i < sorted.length; i++) {
    const cur = sorted[i]
    const prevNum = Number(prev[0])
    const curNum = Number(cur[0])

    if (curNum === prevNum + 1) {
      prev = cur
      continue
    }

    groups.push(start === prev ? start : `${start}-${prev}`)
    start = cur
    prev = cur
  }

  groups.push(start === prev ? start : `${start}-${prev}`)

  // wrap-around: merge trailing ...-7Sun with leading 1Mon-...
  if (groups.length > 1) {
    const first = groups[0]
    const last = groups[groups.length - 1]

    const firstStartNum = getDayNum(getGroupStart(first))
    const lastEndNum = getDayNum(getGroupEnd(last))

    if (firstStartNum === 1 && lastEndNum === 7) {
      const merged = `${getGroupStart(last)}-${getGroupEnd(first)}`
      return [merged, ...groups.slice(1, -1)]
    }
  }

  return groups
}

// "HH:mm:ss - HH:mm:ss" (seconds optional); anything else — incl. the cached
// "null - null" the backend used to emit for NULL hours (QRM-614) — is closed
const TIME_RANGE = /^(\d{2}:\d{2})(?::\d{2})? - (\d{2}:\d{2})(?::\d{2})?$/

export const convertToSchedule = (
  sch?: ScheduleType
): [Array<[string, string]>, string[]] => {
  const schedule: Record<string, string> = {}
  const closed: string[] = []
  if (sch) {
    weekArr.forEach((day) => {
      const match = sch[day]?.match(TIME_RANGE)
      if (match) {
        const newKey = `${match[1]} - ${match[2]}`
        if (schedule[newKey]) {
          schedule[newKey] = schedule[newKey].slice(0, 4) + '-' + week[day]
        } else {
          schedule[newKey] = week[day]
        }
      } else {
        closed.push(week[day])
      }
    })
  }
  return [
    Object.entries(schedule).map(([key, value]) => [value, key]),
    groupConsecutiveDays(closed),
  ]
}
